import {
  CreateLawazimPayload,
  UpdateLawazimStatusPayload,
} from "types/lawazimConfig";
import axiosInstance from "./axiosInstance";

export type ApiRotation = {
  rotationCode: string;
};

export type ApiMiqaat = {
  miqaatName: string;
  rotations: ApiRotation[];
};

// Helper to get token safely
export const getAuthHeader = () => {
  const token = localStorage.getItem("fhims_auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};


export const getAtraafList = async (isActive: boolean) => {
  const res = await axiosInstance.get("/atraaf", {
    params: {
      isActive,
    },
    headers: getAuthHeader(),
  });
  return res.data;
};


export const getPortList = async (isActive: boolean) => {
  const res = await axiosInstance.get("/Ports", {
    params: {
      isActive,
    },
    headers: getAuthHeader(),
  });

  return res.data;
};

export const getPropertyTypesList = async (isActive: boolean) => {
  const res = await axiosInstance.get("/property-types", {
    params: {
      isActive,
    },
    headers: getAuthHeader(),
  });

  return res.data;
};

export const getRoomTypesByProperty = async (propertyPublicId: string) => {
  const res = await axiosInstance.get(
    `/room-type/byProperty/${propertyPublicId}`,
    {
      headers: getAuthHeader(),
    }
  );

  return res.data;
};


export const getLawazimList = async (payload: {
  pageNumber?: number;
  pageSize?: number;
  keyword?: string;
}) => {
  const response = await axiosInstance.post(
    "/Lawazim/search",
    payload
  );
  return response.data;
};


export const createLawazimConfig = async (payload: CreateLawazimPayload) => {
  try {
    const response = await axiosInstance.post(
      "/lawazim",
      payload,
      {
        headers: {
          ...getAuthHeader(),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getPropertyRoomTypes = async (
  propertyPublicIds: string[],
) => {
  const response = await axiosInstance.post(
    "/Lawazim/property-room-types",
    {
      propertyPublicIds,
    },
  );

  return response.data.data;
};


export const deleteLawazimConfig = async (id: string): Promise<void> => {
  await axiosInstance.delete(`/lawazim/${id}`, {
    headers: {
      ...getAuthHeader(),
    },
  });
};


export const updateLawazimConfig = async (payload: CreateLawazimPayload) => {
  try {
    const response = await axiosInstance.put(`/Lawazim`, payload, {
      headers: {
        ...getAuthHeader(),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const UpdateLawazimStatus = async (
  payload: UpdateLawazimStatusPayload,
) => {
  try {
    const response = await axiosInstance.put(
      `/lawazim/${payload.publicId}/${payload.isActive}`,
      {
        isActive: payload.isActive,
        publicId: payload.publicId,
      },
      {
        headers: {
          ...getAuthHeader(),
        },
      },
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};
// update lawazim status 


export const getLawazimByPublicId = async (publicId: string) => {
  try {
    const response = await axiosInstance.get(
      `/Lawazim/${publicId}`,
      {
        headers: {
          ...getAuthHeader(),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const getMiqaatLawazim = async (
  lawazimId: string
): Promise<ApiMiqaat[]> => {
  const response = await axiosInstance.get(
    `/Lawazim/RotationSummary/${lawazimId}`,
    {
      headers: {
        ...getAuthHeader(),
      },
    }
  );

  return response.data;
};